import {Translation} from "react-i18next";
import {t} from "i18next";

const ConfigSelectTable = [
    {
        id: "MONTH",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.month")}</span>}
            </Translation>
        )
    },
    {
        id: "DATE",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.date")}</span>}
            </Translation>
        )
    },
    {
        id: "SHIFT",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.shift")}</span>}
            </Translation>
        )
    },
    {
        id: "OVERTIME",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.overtime")}</span>}
            </Translation>
        )
    },
    {
        id: "MEETING",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.meeting")}</span>}
            </Translation>
        )
    },
    {
        id: "MISSION",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.mission")}</span>}
            </Translation>
        )
    },
    {
        id: "CHECKIN/OUT",
        type: (
            <Translation>
                {(t, {i18n}) => <span>{t("typeArray.checkin/out")}</span>}
            </Translation>
        )
    }
]

export default ConfigSelectTable

export function genderNameSearch(key) {
    switch (key) {
        case "MONTH":
            return t("tnp.components.timekeeping.text37")
        case "DATE":
            return t('timeEngineDetail.shiftWork')
        case "SHIFT":
            return t("typeArray.shift")
        case "OVERTIME":
            return t("tnp.components.timekeeping.text38")
        case "MEETING":
            return t("tnp.components.timekeeping.text39")
        case "MISSION":
            return t("tnp.components.timekeeping.text40")
        case "CHECKIN/OUT":
            return t("tnp.components.timekeeping.text41")
        case "SUB_SUNDAY":
            return t("tnp.components.timekeeping.text42")
        case "SUB_SATURDAY_SUNDAY":
            return t("tnp.components.timekeeping.text43")
        case "SUB_HALF_SATURDAY_SUNDAY":
            return t("tnp.components.timekeeping.text44")
        case "SUB_SUNDAY_OTHER":
            return t("tnp.components.timekeeping.text45")
        case "TOTAL_SHIFT":
            return t("tnp.components.timekeeping.text46")
        case "TOTAL_SHIFT_SUB_NN":
            return t("tnp.components.timekeeping.text47")
        case "SUB_SUNDAY_START_MONTH":
            return t("tnp.components.timekeeping.text48")
        case "SUB_SATURDAY_SUNDAY_START_MONTH":
            return t("tnp.components.timekeeping.text49")
        case "SUB_SUNDAY_END_MONTH":
            return t("tnp.components.timekeeping.text50")
        case "SUB_SATURDAY_SUNDAY_END_MONTH":
            return t("tnp.components.timekeeping.text51")
        case "OTHER":
            return t("tnp.components.timekeeping.text52")
        default:
            return ""
    }
}